import { render, staticRenderFns } from "./PlanRoutes.vue?vue&type=template&id=dac5175e&scoped=true"
import script from "./PlanRoutes.vue?vue&type=script&lang=js"
export * from "./PlanRoutes.vue?vue&type=script&lang=js"
import style0 from "./PlanRoutes.vue?vue&type=style&index=0&id=dac5175e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac5175e",
  null
  
)

export default component.exports